import React from 'react'
import PropTypes from 'prop-types'

const PollTypeIcon = (props) => {
  const { className = 'w-20', fill = '#183560' } = props
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        minHeight: '20px',
        minWidth: '20px',
      }}
    >
      <path
        d="M16.625 3.125H4.375C3.4125 3.125 2.625 3.9125 2.625 4.875V17.125C2.625 18.0875 3.4125 18.875 4.375 18.875H16.625C17.5875 18.875 18.375 18.0875 18.375 17.125V4.875C18.375 3.9125 17.5875 3.125 16.625 3.125ZM16.625 17.125H4.375V4.875H16.625V17.125ZM6.125 9.25H7.875V15.375H6.125V9.25ZM9.625 6.625H11.375V15.375H9.625V6.625ZM13.125 11.875H14.875V15.375H13.125V11.875Z"
        fill={fill}
      />
    </svg>
  )
}

PollTypeIcon.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
}
export default PollTypeIcon
